import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

// Keep open after saving — G14 on the prototype, `household-at-the-desk`.
//
// A tick in the modal footer: off, Save closes the modal as it always has; on,
// the record saves, a Saved mark appears beside the title for a few seconds and
// the modal stays exactly where it was.
//
// OFF ON EVERY OPEN. The tick is a choice for the modal in front of you, not a
// setting. It was remembered per person in localStorage (decision 45); Freddi
// opened a modal, found the tick already on from the last time, and ruled it
// (2026-10-08): "the default should be unticked". So the provider holds plain
// state, is mounted by the modal and so is born with it — ticked, it stays
// ticked for as long as that modal is open, which is the ten-households-in-a-
// row case, and a fresh modal starts off. Nothing is written anywhere.

interface KeepOpenApi {
  on: boolean;
  setOn: (on: boolean) => void;
}

const Ctx = createContext<KeepOpenApi | null>(null);

export function KeepOpenProvider({ children }: { children: ReactNode }) {
  const [on, setOnState] = useState(false);
  const setOn = useCallback((next: boolean) => setOnState(next), []);
  return <Ctx.Provider value={{ on, setOn }}>{children}</Ctx.Provider>;
}

const OFF: KeepOpenApi = { on: false, setOn: () => {} };

/** The tick's state. Outside a provider (tests, the customer app) it reads off and cannot be set. */
export function useKeepOpen(): KeepOpenApi {
  return useContext(Ctx) ?? OFF;
}
